import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import Pagination from "../../Helpers/Pagination";
import { Modal, ModalBody, ModalFooter, Button, Badge, Table, Col, Row } from "reactstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { getCookie } from "../../Helpers/Utils";
import { useNavigate } from "react-router-dom";

const DispatchList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [search, setSearch] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [viewItem, setViewItem] = useState(null);

    // ⭐ STATES
    const [assignModal, setAssignModal] = useState(false);
    const [confirmModal, setConfirmModal] = useState(false);
    const [selectedDispatch, setSelectedDispatch] = useState(null); // Full object for ID mapping
    const [actionType, setActionType] = useState("");

    const [vehicles, setVehicles] = useState([]);
    const [drivers, setDrivers] = useState([]);
    const [selectedVehicle, setSelectedVehicle] = useState(null);
    const [selectedDriver, setSelectedDriver] = useState(null);

    const limit = 20;

    const loadDispatch = async () => {
        dispatch(loadingTrue());
        let url = `/dispatch/list.php?limit=${limit}&page=${page}`;
        if (search) url += `&search=${search}`;
        if (statusFilter) url += `&status=${statusFilter}`;
        if (fromDate) url += `&from_date=${fromDate.format("YYYY-MM-DD")}`;
        if (toDate) url += `&to_date=${toDate.format("YYYY-MM-DD")}`;

        const res = await Handler({ method: "get", url });
        if (res?.success) {
            setData(res?.data);
            setTotal(res?.pagination?.total_rows || res?.total || res?.total_count || 0);
        }
        dispatch(loadingFalse());
    };

    // ⭐ PDF PREVIEW LOGIC
    const handleInvoiceDownload = (quotationId, invoiceId) => {
        const token = getCookie("token");
        dispatch(loadingTrue());

        // fetch(`${process.env.REACT_APP_API_URL || "https://sfsbill.dizoratbd.com/vehicle_api"}/invoice/generate.php`, {
            fetch(`${process.env.REACT_APP_API_URL || "https://sfsbill.dizoratbd.com/sfs-backend"}/invoice/generate.php`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({ quotation_id: quotationId, invoice_id: invoiceId })
        })
            .then(res => {
                if (!res.ok) throw new Error("PDF Generation Failed");
                return res.blob();
            })
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `Invoice_INV-${invoiceId}.pdf`;
                document.body.appendChild(a);
                a.click();
                a.remove();
                dispatch(loadingFalse());
            })
            .catch(err => {
                toast.error("Error generating PDF preview");
                dispatch(loadingFalse());
            });
    };

    const loadDropdowns = async () => {
        const vehRes = await Handler({ method: "get", url: "/vehicle/list.php?status=available" });
        const driRes = await Handler({ method: "get", url: "/driver/list.php?status=active" });
        if (vehRes?.success) setVehicles(vehRes.data.map(v => ({ value: v.id, label: v.vehicle_number })));
        if (driRes?.success) setDrivers(driRes.data.map(d => ({ value: d.id, label: d.name })));
    };

    const handleOpenAssign = (id) => {
        setSelectedDispatch({ id });
        loadDropdowns();
        setAssignModal(true);
    };

    const handleOpenConfirm = (item, type) => {
        setSelectedDispatch(item);
        setActionType(type);
        setConfirmModal(true);
    };

    const handleAssignVehicle = async () => {
        if (!selectedVehicle || !selectedDriver) {
            toast.warning("Select both Vehicle and Driver!");
            return;
        }
        dispatch(loadingTrue());
        const res = await Handler({
            method: "post",
            url: "/dispatch/assign_vehicle.php",
            data: { dispatch_id: selectedDispatch.id, vehicle_id: selectedVehicle.value, driver_id: selectedDriver.value }
        });
        dispatch(loadingFalse());
        if (res?.success) {
            toast.success(res.message);
            setAssignModal(false);
            loadDispatch();
        } else {
            toast.error(res.message);
        }
    };

    const loadDispatchView = async (dispatchId) => {
        dispatch(loadingTrue());
        try {
            // Dispatch view.php API-a hit panrom
            const res = await Handler({
                method: "get",
                url: `/dispatch/view.php?id=${dispatchId}`
            });

            if (res?.success) {
                // Structured response-a (dispatch, customer, assigned_vehicles) state-la vaikkarom
                setViewItem(res.data);
            } else {
                toast.error(res?.message || "Failed to fetch details");
            }
        } catch (error) {
            toast.error("Network error while fetching dispatch details");
        }
        dispatch(loadingFalse());
    };

    const handleStatusAction = async () => {
        let url = "";
        let postData = {};

        if (actionType === "complete") {
            url = "/dispatch/complete.php";
            postData = { dispatch_id: selectedDispatch.id };
        } else {
            // ⭐ Indha place-la thaan quotation_id sethu anupanum
            url = "/invoice/generate.php";
            console.log("Selected Dispatch for Invoice Generation:", selectedDispatch); // Debug log
            postData = {
                invoice_id: selectedDispatch.invoice_id,
                quotation_id: selectedDispatch.quotation_id // Backend indha field-ah ethirpaakudhu
            };
        }

        dispatch(loadingTrue());
        const res = await Handler({ method: "post", url, data: postData });
        dispatch(loadingFalse());

        if (res?.success) {
            toast.success(res.message);
            setConfirmModal(false);

            // ⭐ Invoice status update aana udane PDF download trigger pannum
            if (actionType === "invoice") {
                handleInvoiceDownload(selectedDispatch.quotation_id, selectedDispatch.invoice_id);
            }

            loadDispatch();
        } else {
            toast.error(res.message || "Failed to process request");
        }
    };

    useEffect(() => { loadDispatch(); }, [page, search, statusFilter, fromDate, toDate]);

    return (
        <div className="page-card">
            <div className="page-header flex-wrap gap-3">
                <div className="d-flex align-items-center justify-content-between w-100 flex-wrap gap-3">
                    <h4 className="mb-0">Dispatch Management</h4>
                </div>
                <div className="d-flex gap-2 align-items-center flex-wrap w-100">
                    <div className="search-box flex-grow-1" style={{ minWidth: '200px', maxWidth: '300px' }}>
                        <i className='bx bx-search'></i>
                        <input placeholder="Search..." value={search} onChange={e => { setPage(1); setSearch(e.target.value) }} style={{ width: '100%' }} />
                    </div>
                    <select className="form-select" style={{ width: '150px', height: '38px', borderRadius: '8px' }} value={statusFilter} onChange={(e) => { setPage(1); setStatusFilter(e.target.value); }}>
                        <option value="">All Status</option>
                        <option value="assigned">Assigned</option>
                        <option value="in_progress">In Progress</option>
                        <option value="completed">Completed</option>
                        <option value="invoiced">Invoiced</option>
                    </select>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <div className="d-flex gap-2 align-items-center flex-wrap">
                            <DatePicker label="From" value={fromDate} onChange={(val) => setFromDate(val)} slotProps={{ textField: { size: "small", style: { width: 140 } } }} />
                            <DatePicker label="To" value={toDate} minDate={fromDate || undefined} onChange={(val) => setToDate(val)} slotProps={{ textField: { size: "small", style: { width: 140 } } }} />
                        </div>
                    </LocalizationProvider>
                </div>
            </div>

            <div className="table-wrap">
                <table className="table modern-table">
                    <thead>
                        <tr>
                            <th>Dispatch #</th><th>Date</th><th>Customer</th><th>Vessel</th><th>Pallets</th><th>Status</th><th className="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data?.length === 0 ? (
                            <tr><td colSpan="8" className="text-center">No records found</td></tr>
                        ) : data?.map(d => (
                            <tr key={d.id}>
                                <td className="fw-semibold text-primary text-nowrap">{d.dispatch_number}</td>
                                <td className="text-nowrap">{dayjs(d.dispatch_date).format("DD-MM-YYYY")}</td>
                                <td style={{ maxWidth: '170px' }} className="text-truncate" title={d.company_name}>{d.company_name}</td>
                                <td style={{ maxWidth: '130px' }} className="text-truncate" title={d.vessel_name}>{d.vessel_name || "-"}</td>
                                <td>{d.pallet_count}</td>
                                <td><span className={`badge-status ${d.status}`}>{d.status}</span></td>
                                <td className="text-center">
                                    <div className="d-flex gap-2 justify-content-center">
                                        <button
                                            className="btn btn-sm btn-light border rounded-circle"
                                            onClick={() => navigate(`/dispatch/view/${d.id}`)}
                                        >
                                            <i className="bi bi-eye"></i>
                                        </button>

                                        {d.status === 'assigned' && (
                                            <button className="icon-btn edit text-warning border" title="Assign Vehicle" onClick={() => handleOpenAssign(d.id)}>
                                                <i className='bx bxs-truck'></i>
                                            </button>
                                        )}

                                        {d.status === 'in_progress' && (
                                            <button className="icon-btn edit text-success border" title="Mark as Completed" onClick={() => handleOpenConfirm(d, "complete")}>
                                                <i className='bx bx-check-circle'></i>
                                            </button>
                                        )}

                                        {d.status === 'completed' && (
                                            <button className="icon-btn edit text-primary border" title="Issue Invoice & Download" onClick={() => handleOpenConfirm(d, "invoice")}>
                                                <i className='bx bx-receipt'></i>
                                            </button>
                                        )}

                                        {/* Status invoiced aanadhuku aprom just preview button mattum irukum */}
                                        {d.status === 'invoiced' && (
                                            <button className="icon-btn view text-danger border" title="Download Invoice" onClick={() => handleInvoiceDownload(d.quotation_id, d.invoice_id)}>
                                                <i className='bx bxs-file-pdf'></i>
                                            </button>
                                        )}

                                        {d.id && (
                                            <button
                                                className="btn btn-sm btn-success border rounded-circle shadow-sm"
                                                title="Go to Execution Mode"
                                                onClick={() => navigate(`/dispatch/complete/${d.id}`)}
                                            >
                                                <i className="bi bi-play-circle-fill text-white"></i>
                                            </button>
                                        )}
                                        <button className="btn btn-sm btn-danger border rounded-circle shadow-sm ms-1" title="Cancel/Soft Delete Dispatch"
                                            onClick={async () => {
                                                if (window.confirm(`Are you sure you want to soft delete dispatch #${d.dispatch_number}?`)) {
                                                    dispatch(loadingTrue());
                                                    const res = await Handler({
                                                        method: "post",
                                                        url: "/dispatch/delete.php",
                                                        data: { id: d.id }
                                                    });
                                                    dispatch(loadingFalse());
                                                    if (res?.success) {
                                                        loadDispatch();
                                                    }
                                                }
                                            }}>
                                            <i className="bi bi-trash-fill text-white"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <Pagination page={page} total={total} limit={limit} onPrev={() => setPage(p => Math.max(1, p - 1))} onNext={() => setPage(p => p + 1)} />

            {/* ⭐ ASSIGN MODAL */}
            <Modal isOpen={assignModal} toggle={() => setAssignModal(false)} centered>
                <div className="p-4">
                    <h5 className="mb-3">Assign Vehicle & Driver</h5>
                    <div className="mb-3">
                        <label className="small fw-bold">Vehicle</label>
                        <Select options={vehicles} onChange={setSelectedVehicle} placeholder="Search Vehicle..." isClearable />
                    </div>
                    <div className="mb-4">
                        <label className="small fw-bold">Driver</label>
                        <Select options={drivers} onChange={setSelectedDriver} placeholder="Search Driver..." isClearable />
                    </div>
                    <div className="d-flex gap-2">
                        <Button color="light" className="flex-grow-1" onClick={() => setAssignModal(false)}>Cancel</Button>
                        <Button color="primary" className="flex-grow-1" onClick={handleAssignVehicle}>Assign Now</Button>
                    </div>
                </div>
            </Modal>

            {/* ⭐ CONFIRM ACTION MODAL */}
            <Modal isOpen={confirmModal} toggle={() => setConfirmModal(false)} centered size="sm">
                <div className="p-4 text-center">
                    <div className="mb-3">
                        <i className={`bx ${actionType === 'complete' ? 'bx-check-circle text-success' : 'bx-receipt text-primary'} display-4`}></i>
                    </div>
                    <h5>{actionType === 'complete' ? "Complete Dispatch?" : "Issue & Generate Invoice?"}</h5>
                    <p className="small text-muted">
                        {actionType === 'invoice' ? "This will officially issue the invoice and download the PDF." : "Are you sure you want to complete this dispatch?"}
                    </p>
                    <div className="d-flex gap-2 mt-4">
                        <Button color="light" className="flex-grow-1" onClick={() => setConfirmModal(false)}>No</Button>
                        <Button color={actionType === 'complete' ? "success" : "primary"} className="flex-grow-1" onClick={handleStatusAction}>Yes, Sure</Button>
                    </div>
                </div>
            </Modal>

            {/* VIEW MODAL (Unnoda Style) */}
            <Modal isOpen={!!viewItem} toggle={() => setViewItem(null)} centered size="lg">
                <ModalBody className="p-0 overflow-hidden rounded-4">
                    {/* Modal Header Banner */}
                    <div className="modal-banner p-4 text-white" style={{ background: 'linear-gradient(45deg, #1e3c72, #2a5298)' }}>
                        <div className="d-flex justify-content-between align-items-start">
                            <div>
                                <h4 className="fw-bold mb-1">{viewItem?.dispatch?.dispatch_number}</h4>
                                <p className="mb-0 opacity-75"><i className="bi bi-calendar3 me-2"></i>Date: {viewItem?.dispatch?.dispatch_date}</p>
                            </div>
                            <Badge color="light" className="text-primary px-3 py-2 rounded-pill shadow-sm">
                                {viewItem?.dispatch?.status?.toUpperCase()}
                            </Badge>
                        </div>
                    </div>

                    <div className="p-4 bg-light bg-opacity-50">
                        <Row className="g-4">
                            {/* Logistics Details */}
                            <Col md={6}>
                                <div className="bg-white p-3 rounded-4 shadow-sm border h-100">
                                    <h6 className="fw-bold text-primary mb-3 text-uppercase small">Logistics Info</h6>
                                    <div className="mb-2 small"><strong>Vessel:</strong> {viewItem?.dispatch?.vessel_name || 'N/A'}</div>
                                    <div className="mb-2 small"><strong>Goods:</strong> {viewItem?.dispatch?.goods_description}</div>
                                    <div className="mb-2 small"><strong>Pallets:</strong> <Badge color="dark" pill>{viewItem?.dispatch?.pallet_count} Units</Badge></div>
                                    <hr className="my-2 opacity-50" />
                                    <div className="small">
                                        <div className="text-muted extra-small fw-bold">ROUTE</div>
                                        <div className="fw-bold text-dark">{viewItem?.dispatch?.discharge_point} <i className="bi bi-arrow-right mx-1 text-primary"></i> {viewItem?.dispatch?.end_point}</div>
                                    </div>
                                </div>
                            </Col>

                            {/* Customer & Ref */}
                            <Col md={6}>
                                <div className="bg-white p-3 rounded-4 shadow-sm border h-100">
                                    <h6 className="fw-bold text-primary mb-3 text-uppercase small">Customer & Reference</h6>
                                    <div className="mb-1 fw-bold text-dark">{viewItem?.customer?.company_name}</div>
                                    <div className="mb-1 small text-muted"><i className="bi bi-person me-2"></i>{viewItem?.customer?.contact_person}</div>
                                    <div className="mb-3 small text-muted"><i className="bi bi-telephone me-2"></i>{viewItem?.customer?.phone}</div>
                                    <div className="p-2 bg-light rounded-3 small border-start border-primary border-4">
                                        <strong>Quotation:</strong> {viewItem?.quotation?.quotation_number}
                                    </div>
                                </div>
                            </Col>

                            {/* Assigned Vehicles & Drivers */}
                            <Col md={12}>
                                <div className="bg-white p-3 rounded-4 shadow-sm border">
                                    <h6 className="fw-bold text-primary mb-3 text-uppercase small">Assigned Resources ({viewItem?.assigned_vehicles?.length})</h6>
                                    <div className="table-responsive">
                                        <Table size="sm" className="mb-0 align-middle">
                                            <thead className="small text-muted">
                                                <tr>
                                                    <th>Vehicle Number</th>
                                                    <th>Lorry Type</th>
                                                    <th>Driver Name</th>
                                                    <th>Phone</th>
                                                </tr>
                                            </thead>
                                            <tbody className="small">
                                                {viewItem?.assigned_vehicles?.map((v, idx) => (
                                                    <tr key={idx}>
                                                        <td className="fw-bold text-dark">{v.vehicle_number}</td>
                                                        <td><Badge color="info" outline className="fw-normal">{v.lorry_type}</Badge></td>
                                                        <td>{v.driver_name}</td>
                                                        <td>{v.driver_phone}</td>
                                                    </tr>
                                                ))}
                                                {viewItem?.assigned_vehicles?.length === 0 && (
                                                    <tr><td colSpan="4" className="text-center py-3 text-muted italic">No vehicles assigned to this dispatch.</td></tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <div className="mt-4 text-end">
                            <Button color="secondary" outline className="px-5 rounded-pill shadow-sm" onClick={() => setViewItem(null)}>
                                Close Details
                            </Button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default DispatchList;